export default __webpack_public_path__ + "static/3-f02aa15983eedad42d1a1e4d2850eab9.jpg";